// src/lib/tableSort.js — 관리자 표 머리글 정렬(2026-10-19 게시판 t165bky9 김준동)
// ---------------------------------------------------------------------------
// 배차 관리·배차 일정·노선 관리 표의 머리글을 누르면 그 칸으로 정렬한다.
// 누를 때마다 오름차순 → 내림차순 → 해제(그 화면의 원래 순서) 순으로 돈다.
// 🔴 해제 단계를 없애지 말 것 — 노선 관리는 원래 순서가 «승객앱 표시 순서»라
//    정렬을 못 풀면 ▲▼ 순서 변경을 다시 쓸 수 없다.
// 순수 모듈(React·Firebase import 0) — scripts/test_table_sort.cjs 가 vm 으로 태운다.

const collator = new Intl.Collator("ko", { numeric: true, sensitivity: "base" });

// 다음 정렬 상태. sort = { key, dir: "asc"|"desc" } | null
export function nextSort(cur, key) {
  if (!cur || cur.key !== key) return { key, dir: "asc" };
  if (cur.dir === "asc") return { key, dir: "desc" };
  return null;
}

function isBlank(v) {
  return v === null || v === undefined || v === "" || v === "–" || (typeof v === "number" && !Number.isFinite(v));
}

// 값 비교 — 숫자는 숫자로, 글자는 한국어 순서(숫자 섞인 이름은 자연 순서: 2호 < 10호).
// "HH:MM" 출발시각도 자연 순서로 맞게 선다.
export function compareCell(a, b) {
  if (typeof a === "number" && typeof b === "number") return a - b;
  if (typeof a === "boolean" || typeof b === "boolean") return Number(!!a) - Number(!!b);
  return collator.compare(String(a), String(b));
}

// rows 를 sort 대로 정렬한 새 배열. 빈 값은 방향과 무관하게 늘 맨 뒤.
// 같은 값끼리는 원래 순서를 지킨다(안정 정렬).
export function sortRows(rows, sort, getters) {
  const list = Array.isArray(rows) ? rows : [];
  if (!sort || !getters || typeof getters[sort.key] !== "function") return list;
  const get = getters[sort.key];
  const sign = sort.dir === "desc" ? -1 : 1;
  return list
    .map((row, i) => ({ row, i, v: get(row) }))
    .sort((x, y) => {
      const xb = isBlank(x.v), yb = isBlank(y.v);
      if (xb || yb) return xb === yb ? x.i - y.i : xb ? 1 : -1;
      return sign * compareCell(x.v, y.v) || x.i - y.i;
    })
    .map((e) => e.row);
}

// 머리글 옆 표시
export function sortMark(sort, key) {
  if (!sort || sort.key !== key) return "↕";
  return sort.dir === "asc" ? "▲" : "▼";
}
